import React, { useState, useContext } from 'react';
import { getTableLimit } from 'libs/utils';

export interface IAppContext {
  tableLimit: number;
  setTableLimit: Function;
}

// Keep Track of global values that can be updated in the App
const AppContext = React.createContext<IAppContext>({
  tableLimit: getTableLimit(),
  setTableLimit: () => {},
});

const AppSettingsProvider: React.FC = ({ children }) => {
  const [tableLimit, setTableLimit] = useState<number>(getTableLimit());

  const contextValue = {
    setTableLimit,
    tableLimit,
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export const useAppSettings = () => {
  return useContext(AppContext);
};

export default AppSettingsProvider;
